import { render, staticRenderFns } from "./DailyParent.vue?vue&type=template&id=c97abe56&scoped=true"
import script from "./DailyParent.vue?vue&type=script&lang=js"
export * from "./DailyParent.vue?vue&type=script&lang=js"
import style0 from "./DailyParent.vue?vue&type=style&index=0&id=c97abe56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97abe56",
  null
  
)

export default component.exports